import { createStore } from "solid-js/store";
import { useApplication } from "@/context/app";
import { get, save } from "../requests/patient";
import { createSignal, onMount } from "solid-js";

export default function usePatient(props) {
  const [key, setKey] = createSignal(null);
  const [loading, setLoading] = createSignal(false);
  const [fetching, setFetching] = createSignal(false);
  const [showAssociate, setShowAssociate] = createSignal(false);

  const [genders, setGenders] = createSignal([
    { value: "Male", text: "Male" },
    { value: "Female", text: "Female" },
    { value: "Other", text: "Other" },
    { value: "N/A", text: "N/A" },
  ]);
  const [bloodGroups, setBloodGroups] = createSignal([
    { value: "A+", text: "A+" },
    { value: "A-", text: "A-" },
    { value: "B+", text: "B+" },
    { value: "B-", text: "B-" },
    { value: "O+", text: "O+" },
    { value: "O-", text: "O-" },
    { value: "AB+", text: "AB+" },
    { value: "AB-", text: "AB-" },
    { value: "N/A", text: "N/A" },
  ]);
  const [types, setTypes] = createSignal([
    { value: "self", text: "Self" },
    { value: "child", text: "Child" },
    { value: "other", text: "Other" },
  ]);

  const [form, setForm] = createStore({
    name: "",
    gender: null,
    bloodGroup: null,
    birthDate: new Date().toISOString().split('T')[0],
    type: "self",
    associateName: "",
    cnic: "",
    phone: "",
    email: "",
  });

  const { successToast, errorToast } = useApplication();

  const fetchInfo = async (pid) => {
    setLoading(true);
    setKey(pid);
    try {
      const data = await get(key());
      setForm('name', data.entity.name);
      setForm('gender', data.entity.gender);
      setForm('bloodGroup', data.entity.bloodGroup);
      setForm('birthDate', data.entity.birthDate);
      setForm('type', data.entity.type);
      setForm('associateName', data.entity.associateName);
      setForm('cnic', data.entity.cnic);
      setForm('phone', data.entity.phone);
      setForm('email', data.entity.email);
    } catch (error) {
      throw error;
    }  finally {
      setLoading(false);
    }
  }

  const handleSave = async(ev) => {
    ev.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData();
      Object.keys(form).forEach(key => formData.append(key, form[key]));

      if (form.type === 'self') {
        formData.set('associateName', form.name);
      }

      const data = await save(formData);

      if (data.success) {
        successToast(data.message);
        return;
      }

    } catch (error) {
      errorToast(error);
    } finally {
      setLoading(false);
    }
  }

  const handleChange = (name, value) => {
    setForm([name], value);

    if (name === 'type' && value === 'self') {
      setShowAssociate(false);
    } else if (name === 'type' && value !== 'self') {
      setShowAssociate(true);
    }
  };

  const clearForm = () => {
    setForm({
      name: "",
      gender: null,
      bloodGroup: null,
      birthDate: new Date().toISOString().split('T')[0],
      type: "self",
      associateName: "",
      cnic: "",
      phone: "",
      email: "",
    });
  }

  return {
    form,
    fetchInfo,
    loading,
    fetching,
    genders,
    bloodGroups,
    types,
    showAssociate,
    handleChange,
    handleSave,
    clearForm,
  };
}
